<template>
  <div class="ls_div">
    <banner title="新闻资讯" :img="sty" />
    <div class="ls_setion">

      <div>
        <el-form :inline="true">
          <el-form-item label="提单号查询">
            <el-input
							clearable
              v-model="billNo"
              placeholder="提单号查询"
            ></el-input>
						<span style="display:block; font-size: 14px; color: #F60;">请输入完整的提单号 进行查询</span>
          </el-form-item>
					
          <el-form-item>
            <el-button type="primary" @click="gotoSearch">查询</el-button>
          </el-form-item>
        </el-form>

        <img class="wuliuimg" src="../assets/img/wuliuflow.png" alt="" />

        <div class="detail" v-if="tableData.length">
          <el-table
            :data="tableData"
            border
						stripe
            style="width: 100%"
          >
            <el-table-column
              v-for="item in cloumns"
              :key="item.label"
              :prop="item.prop"
              :label="item.label"
              width="170"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>

					<!-- 分页 -->
					<div class="pagebox">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="curPage"
							:page-sizes="[10, 50, 100]"
							:page-size="pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="totalRow"
						></el-pagination>
					</div>
        </div>
      </div>
    </div>

		<el-dialog title="输入验证码" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="500px">
			<div class="confirm clearfix">
				<div class="input yanzheng">
					<el-input clearable type="text" placeholder="请输入验证码" oninput="value=value.replace(/[^\d]/g,'')" v-model="confirm"></el-input>
				</div>
				<div class="code">
					<s-identify :identifyCode="identifyCode"></s-identify>
					<p @click="refreshCode" style="height: 28px;line-height: 28px;font-size: 14px;text-align: center;color: #5d5d5d;cursor: pointer;">看不清 换一张</p>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="gotoVerify">确 定</el-button>
			</div>
		</el-dialog>
  </div>
</template>

<script>
import { get } from "core-js/core/dict";
import Banner from "../components/Banner";
import SIdentify from "../components/identify.vue";
export default {
  name: "HelloWorld",
  components: {
    Banner,
		SIdentify
  },
  data() {
    return {
			billNo: '',
			pageSize: 10,
			curPage: 1,
			tableData: [],
			dialogFormVisible: false,
			confirm: '',
			identifyCode: '',
			cloumns:[{
        label: '起运港',
        prop: 'start_harbor'        	
      },{
        label: '二承运',
        prop: 'accept_carriage'        	
      },{
        label: '提单号',
        prop: 'bill_no'        	
      },{
        label: '集装箱号',
        prop: 'box_no'        	
      },{
        label: 'Sz',
        prop: 'sz'        	
      },{
        label: 'Tp',
        prop: 'tp'        	
      },{
        label: 'F/L',
        prop: 'fl'        	
      },{
        label: '干线船名',
        prop: 'ship_name'        	
      },{
        label: '干线航次',
        prop: 'flight_number'        	
      },{
        label: '干线船期',
        prop: 'sail_schedule'        	
      },{
        label: '中转港代码',
        prop: 'transit_code'        	
      },{
        label: '目的港',
        prop: 'aim_harbor'        	
      },{
        label: '货物类别',
        prop: 'type'        	
      },{
        label: '海放(票)',
        prop: 'open_sea'        	
      },{
        label: '码放(票)',
        prop: 'put'        	
      },{
        label: '预配舱单',
        prop: 'pre_no'        	
      },{
        label: '危类',
        prop: 'danger'        	
      },{
        label: '温度',
        prop: 'temperature'        	
      },{
        label: '进场时间',
        prop: 'in_time'        	
      },{
        label: '进场方式',
        prop: 'in_type'        	
      },{
        label: '出场时间',
        prop: 'out_time'        	
      },{
        label: '出场方式',
        prop: 'out_type'        	
      },{
        label: '来源',
        prop: 'source'        	
      },{
        label: '海关放关',
        prop: 'release'        	
      },{
        label: '海放结果',
        prop: 'release_result'        	
      },{
        label: '海关放关时间',
        prop: 'release_time'        	
      },{
        label: '码头放行',
        prop: 'pass'        	
      },{
        label: '码头配载',
        prop: 'stowage'        	
      }],
      list: [
        {
          img: require("@/assets/home/svg1.png"),
          p1: "货物跟踪",
          p2: "Cargo tracking",
          icon1: "car2",
        },
        {
          img: require("@/assets/home/svg1.png"),
          p1: "搜索船期表",
          p2: "Shipping schedule",
          icon1: "shi1",
        },
        {
          img: require("@/assets/home/svg1.png"),
          p1: "运价查询",
          p2: "Freight inquiry",
          icon1: "fre1",
        },
      ],
      sty: {
        // backgroundImage: "url(" + require("@/assets/home/banner2.png") + ")",
      },
    };
  },
  methods: {
		gotoVerify(){
			if(!this.confirm.trim()){
				this.$message.warning('请输入验证码')
				return false;
			}
			if(this.confirm == this.identifyCode){
				this.onSubmit();
				this.dialogFormVisible = false;
				this.$nextTick(()=>{
					this.confirm = '';
				})
			}else{
				this.$message.warning('验证码错误，请重新输入')
				this.refreshCode();
			}
		},
		refreshCode() {
				this.$axios({
					method: 'post',
					url: '/sysmenu/loginKey',
					params: {
						'x-access-token': this.token,
						'keyid':this.token
					}
				}).then((res) => {
					this.identifyCode = res.data.detail.vcode;
					this.times = res.data.detail.times;
				});
			},
		gotoSearch(){
			if(!this.billNo.trim()){
				this.$message.warning('请输入提单号进行查询')
				return false;
			}
			this.dialogFormVisible = true;
			this.refreshCode();
		},
    onSubmit() {
			this.curPage = 1;
			this.getList();
    },
		getList(){
      this.$axios({
				method: "get",
				url: "webpc/customs/list",
				params: {
					billNo: this.billNo,
					page: this.curPage,
					pagesize: this.pageSize
				}
			})
			.then((res) => {
				if (res.data.result == 200) {
					console.log(res.data);
					let data = res.data.detail;
					this.tableData = data.list;
					this.totalRow = data.totalRow;
					if(this.tableData.length == 0){
						this.$message.warning('暂无相关数据')
					}
				}else{
					this.$message.warning(res.data.description)
				}
			});
		},
    getlunbo() {
      var that = this;
      that
        .$axios({
          method: "get",
          url: "system/pcmanage/list",
          // data: this.$qs.stringify(data)
          params: {
            location: 3,
          },
        })
        .then((res) => {
          // console.log(JSON.stringify(res.data));
          // console.log(res.data.data);
          if (res.data.result == 200) {
            console.log(res.data);
            var data = res.data.detail;
            that.sty = {
              backgroundImage: "url(" + data[0].showpath + ")",
            };
          }
        });
    },
    handelClickSubMit() {
      //查询按钮
      this.$message.warning("正在建设中...");
    },
    handleClick(tab, event) {
      let index = tab.index;
      this.list.forEach((item) => {
        console.log(item.icon1);
        item.icon1 = item.icon1.replace("2", "1");
      });
      this.list[index].icon1 = this.list[index].icon1.replace("1", "2");
    },
    getImgUrl(icon) {
      //展示图片
      return require(`@/assets/navigation/${icon}.png`);
    },
		//切换每页展示条数
		handleSizeChange(val) {
			this.pageSize = val;
			this.getList();
		},
		//切换页数
		handleCurrentChange(val) {
			this.curPage = val;
			this.getList();
		},
  },
  mounted() {
    this.getlunbo();
  },
};
</script>

<style lang="scss" scoped>
.ls_div {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: #f5f5f5;

  .ls_setion {
    width: 64%;
    margin: 20px auto;
    background: #ffffff;
    padding: 40px;
    box-sizing: border-box;
		min-height: 50vh;
    .wuliuimg {
      display: block;
      width: 50%;
      margin: 30px auto 60px;
    }
  }
	.pagebox {
		margin: 20px 0;
		text-align: right;
	}

	.confirm {
		display: flex;
		justify-content: space-between;
	}
	
	
	
}
</style>
